import { render } from "./AccountLists.vue?vue&type=template&id=71a830be&ts=true"
import script from "./AccountLists.vue?vue&type=script&lang=ts"
export * from "./AccountLists.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__